var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "kb-files" },
    [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "title" }, [_vm._v("Files")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "actions" },
          [
            _c(
              "SupsisButton",
              { attrs: { primary: "" }, on: { click: _vm.selectFile } },
              [
                _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
                _vm._v(" "),
                _c("span", [_vm._v("Add file")]),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.files.length
        ? _c("div", [
            _c("div", [
              _c(
                "div",
                [
                  _c("ve-pagination", {
                    attrs: {
                      total: _vm.total,
                      "page-index": _vm.page,
                      "page-size": _vm.pageSize,
                      "page-size-option": [1, 10, 15, 20, 50, 100],
                    },
                    on: {
                      "on-page-number-change": function (val) {
                        return (_vm.page = val)
                      },
                      "on-page-size-change": function (val) {
                        return (_vm.pageSize = val)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "files" },
                _vm._l(_vm.files, function (kb) {
                  return _c("div", { key: kb._id, staticClass: "file" }, [
                    _c("div", { staticClass: "file-body" }, [
                      _c("div", { staticClass: "file-icon" }, [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v(_vm._s(_vm.getFileIconType(kb))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "file-name" }, [
                        _vm._v(_vm._s(_vm.getFileName(kb))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "file-actions" },
                      [
                        _c(
                          "a-tooltip",
                          { attrs: { placement: "top", title: "Delete" } },
                          [
                            _c(
                              "SupsisButton",
                              {
                                attrs: {
                                  small: "",
                                  ghost: "",
                                  disabled: _vm.loading,
                                },
                                on: {
                                  click: function () {
                                    return _vm.deleteFile(kb)
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("delete"),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "a-tooltip",
                          { attrs: { placement: "top", title: "Open file" } },
                          [
                            _c(
                              "SupsisButton",
                              {
                                attrs: {
                                  small: "",
                                  ghost: "",
                                  disabled: _vm.loading,
                                },
                                on: {
                                  click: function () {
                                    return _vm.openFile(kb)
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("open_in_new"),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ])
                }),
                0
              ),
            ]),
          ])
        : _c("ComingSoon", {
            attrs: {
              "action-text": "Add file",
              "no-data-text": "No file added",
              addContent: _vm.selectFile,
              disabled: false,
            },
          }),
      _vm._v(" "),
      _vm.uploading
        ? _c(
            "div",
            { staticClass: "uploading-banner" },
            [
              _c("a-progress", {
                attrs: {
                  type: "circle",
                  "stroke-color": {
                    "0%": "#fff",
                    "100%": "#108ee9",
                  },
                  percent: _vm.uploadProgress,
                },
              }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("chatbotv2.fileUploading")))]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }